import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { toastFactory } from '@/factories'
import { getApiErrorMessage } from '@/utils/error'

interface SendReminderChecklistRequest {
  buildingId: number
  checklistId: number
  clientId: number
}

export const sendReminderChecklist = async (data: SendReminderChecklistRequest) => {
  const response = await authAPI.post(`/checklist/reminder`, data)
  return response.data
}

export const useSendReminderChecklist = () => {
  return useMutation({
    mutationFn: sendReminderChecklist,
    onError: (error) => {
      toastFactory.error(getApiErrorMessage(error))
    },
    onSuccess: () => {
      toastFactory.success('Reminder sent successfully')
    },
  })
}
